import { UpdateProfessionalApprovalDTO } from "@/domain/dto/UpdateProfessionalApprovalDTO";
import { PaginatedListResponse } from "@/domain/dto/BaseDataResponse";
import { ListProfessionalsQueryParamsDTO } from "@/domain/dto/ListProfessionalsQueryParamsDTO";
import { EligibleProfessional } from "@/domain/entities/EligibleProfessional";
import { Professional } from "@/domain/entities/Professional";
import { IProfessionalRepository } from "@/domain/repositories/IProfessionalRepository";
import { IProfessionalRemoteDataSource } from "../datasources/interfaces/remote/IProfessionalRemoteDataSource";
import ProfessionalDataMappers from "../mappers/ProfessionalDataMappers";
import ResponseDataMappers from "../mappers/ResponseDataMappers";

export class ProfessionalRepository implements IProfessionalRepository {
    dataSource: IProfessionalRemoteDataSource
    constructor(dataSource: IProfessionalRemoteDataSource) {
        this.dataSource = dataSource
    }
    async getDetail(userId: string): Promise<Professional> {
        const response = await this.dataSource.getDetail(userId)
        return ProfessionalDataMappers.toDomain(response.data)
    }
    async updateApproval(params: UpdateProfessionalApprovalDTO): Promise<void> {
        return this.dataSource.updateApproval(params)
    }
    async listProfessionals(params: ListProfessionalsQueryParamsDTO): Promise<PaginatedListResponse<EligibleProfessional>> {
        const response = await this.dataSource.listProfessionals(params)
        return ResponseDataMappers.toPaginatedListResponse(response, ProfessionalDataMappers.toEligibleDomainList(response.data))
    }
}
